export const createTraineePosition = (payload: { position_id: string }) => ({
    type: "@saga/CREATE_TRAINEE_POSITION",
    payload
});

